import { utility } from '@phi/components';
import { Unary } from '@vaaas/fpts/data';
import { defineComponent, h, PropType } from 'vue';

export const FormNumber = defineComponent({
    props: {
        value: {
            required: true,
            type: null as any as PropType<number | undefined>,
        },

        placeholder: {
            required: false,
            type: String,
        },

        change: {
            required: false,
            type: Boolean,
            default: false,
        },

        validator: {
            required: false,
            type: Function as PropType<Unary<unknown, boolean>>,
        },

        max: {
            required: false,
            type: Number,
        },

        min: {
            required: false,
            type: Number,
        },
    },

    emits: {
        'update:value': (x: number) => true,
    },

    methods: {
        update(x: InputEvent) {
            const target = x.target as HTMLInputElement;
            const value = target.valueAsNumber;
            if (Number.isNaN(value))
                this.force_rerender();
            else if(this.validator && !this.validator(value))
                this.force_rerender();
            else
                this.$emit('update:value', target.valueAsNumber);
        },

        do_nothing() { return; },

        force_rerender() { this.key++; },
    },

    data() {
        return {
            key: Number.MIN_SAFE_INTEGER,
        };
    },

    render() {
        return h('input', {
            key: this.key,
            class: {
                'form-number': true,
                'p-2': true,
                [utility.round]: true,
                [utility.fs_reset]: true,
                'w-100': true,
                'h-2': true,
            },
            type: 'number',
            value: this.value,
            onInput: this.change ? this.do_nothing : this.update,
            onChange: this.change ? this.update : this.do_nothing,
            placeholder: this.placeholder,
            autocomplete: 'off',
            max: this.max,
            min: this.min,
        });
    }
});
